var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['plan-title', 'mdn-Text', _vm.leftAlign ? 'left-align' : ''].join(' ')},[_c('h2',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }